@import "../shared/sw-recommended-flag/sw-recommended-flag";
@import "../shared/sw-skeleton/sw-skeleton";
@import "../shared/sw-activity-log-icon/sw-activity-log-icon";
@import "./media-queries";
@import "../shared/sw-challenge-badge/sw-challenge-badge";
@import "../shared/challenge-banner/challenge-banner.scss";

sw-app {
  label {
    font-size: calc(
      var(--ion-header-size, 26px) - var(--ion-header-step, 2px) * 6
    );
    line-height: calc(
      var(--ion-header-size, 26px) - var(--ion-header-step, 2px) * 6
    );
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  label {
    min-height: 1.2em;
    &.light {
      color: #fff;
    }
  }
  .toolbar-ios ion-title {
    padding: 0 44px 1px;
  }
  ion-back-button.ios {
    --padding-start: 10px;
    --padding-end: 10px;
  }
  ion-list {
    background: transparent !important;
  }
  ion-item-divider {
    text-transform: uppercase;
    --background: transparent !important;
    border-bottom: 0.55px solid var(--ion-border-color);
    font-size: 14px;
  }

  ion-item {
    --ion-background-color: var(--ion-color-step-0);
    --background-hover: var(--ion-color-step-50);

    &.large {
      --min-height: 84px;
      --inner-padding-top: 12px;
      --inner-padding-bottom: 12px;
    }
    &.medium {
      --min-height: 54px;
      --inner-padding-top: 12px;
      --inner-padding-bottom: 12px;
    }
    ion-label.ion-text-wrap {
      font-size: inherit !important;
      line-height: inherit !important;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    label {
      margin: 0;
    }
    p,
    label {
      color: var(--ion-text-color-step-250);
    }
    .number-with-label {
      text-align: center;
      h2 {
        margin-bottom: -4px;
      }
      label {
        text-transform: uppercase;
        font-size: 10px;
        letter-spacing: 0.25px;
      }
      ion-input {
        font-weight: 800;
        font-size: 24px;
        --padding-start: 0;
        --padding-end: 0;
        --padding-top: 0;
        --padding-bottom: 0;
      }
    }
    .sw-image-wrapper {
      width: 60px;
      margin-right: 10px;
      align-items: center;
      display: flex;
      height: 100%;
      flex: none;
      img {
        border-radius: 8px;
      }
      &.square {
        width: 40px;
        height: 40px;
        align-items: center;
        display: flex;
        border-radius: 8px;
        overflow: hidden;
        position: relative;
        img {
          position: absolute;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    .circle-marker {
      width: 32px;
      height: 32px;
      border-radius: 16px;
      background: var(--color-sw-blue);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  ion-button {
    font-weight: 700;
    --border-width: 1px;
    :root[mode="md"] & {
      font-weight: 800;
    }
    &.sw-button-select {
      font-weight: normal !important;
      --border-style: solid;
      --border-color: var(--ion-color-primary);
      text-transform: none;
      &.button-small {
        font-size: 16px;
      }
      &.ion-color-medium {
        --border-color: var(--ion-text-color-secondary);
        --ion-color-base: var(--ion-color-step-0) !important;
        --ion-color-tint: var(--ion-color-step-150) !important;
        --ion-color-contrast: var(--ion-text-color-secondary) !important;
      }
    }
  }
  :root[mode="md"] & {
    ion-toolbar {
      ion-buttons ion-button {
        font-weight: 500 !important;
      }
    }
  }
  :root[mode="ios"] & {
    .searchbar-input-container {
      --background: var(--ion-color-step-100);
    }
  }

  ion-header ion-toolbar {
    --background: var(--ion-color-step-0);
    ion-menu-button,
    ion-back-button,
    ion-buttons:first-child ion-button {
      color: var(--ion-text-color) !important;
    }
    &.has-subtitle {
      --min-height: 65px;
      small {
        display: block;
        font-size: 12px;
      }
    }
    // --padding-top: calc(var(--ion-safe-area-top, 20px) + 4px);
    // --padding-top: var(--ion-safe-area-top);

    // :root[mode='md'] & {
    //   @media screen and (max-width: 576px) {
    //     --padding-top: calc(var(--ion-safe-area-top) + 16px);
    //   }
    // }
  }

  ion-action-sheet {
    color: var(--ion-text-color);
    .action-sheet-title {
      --color: var(--ion-text-color);
      height: inherit !important;
    }
    .action-sheet-sub-title {
      padding-top: 2px !important;
      font-size: 0.75em !important;
    }

    &.left-align
      .action-sheet-group:not(.action-sheet-group-cancel)
      .action-sheet-button-inner {
      justify-content: left;
      text-align: left;
      ion-icon {
        margin-right: 12px !important;
        flex: none;
      }
    }
  }

  ion-header {
    sw-logo svg {
      max-height: 20px;
      vertical-align: middle;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .footer-cta {
    color: var(--ion-text-color);
    padding: 16px;
    ion-button {
      margin: 0;
      &:nth-child(2) {
        margin-top: 14px;
        // margin-bottom: 10px;
      }
      margin-left: var(--ion-safe-area-left);
      margin-right: var(--ion-safe-area-right);
      margin-bottom: 10px;
      // :root[mode="ios"] & {
      //   margin-bottom: 10px;
      // }
    }
    &:after {
      content: "";
      position: relative;
      display: block;
    }
    background: var(--ion-color-step-0);
    backdrop-filter: none;
    animation: slideInAfterTransition 0.35s ease-in-out;
    @keyframes slideInAfterTransition {
      0% {
        opacity: 0;
        transform: translateY(100%);
      }
      100% {
        opacity: 1;
        transform: translateY(0%);
      }
    }
    > div.footer-button-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: end;
      gap: 8px;
      ion-button {
        width: 100%;
        &:nth-child(2) {
          margin-top: 0;
        }
      }
      @media (orientation: landscape) {
        flex-direction: row;
        ion-button {
          margin: 0 !important;
        }
      }
    }
    &.footer-ios {
      border-top: 1px solid var(--ion-border-color);
    }
    &.no-animation {
      animation: none;
    }
  }
  .safe-area-bottom {
    height: var(--ion-safe-area-bottom);
  }
  .sw-new-badge {
    background: var(--color-sw-orange);
    color: #fff;
    font-weight: 700;
    font-size: 12px;
    padding: 4px 8px 4px;
    min-height: 22px;
    border-radius: 11px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    animation: popInBadge 0.35s cubic-bezier(0, 0, 0.57, 1.22);
  }
  @keyframes popInBadge {
    0% {
      opacity: 0;
      transform: scale(0.01);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
  ion-range {
    --bar-background: var(--ion-color-step-100);
  }
  ion-segment[color="primary"] ion-segment-button.ios {
    --color-checked: #fff;
    --indicator-color: var(--ion-color-primary);
    --ion-color-step-350: var(--ion-color-primary);
    &.segment-button-checked {
      color: #fff;
    }
    ion-label {
      padding: 0 8px;
    }
  }
  ion-segment[color="secondary"] {
    &.ios {
      // Selected (active) button
      --color-checked: var(
        --color-sw-blue,
        #60baf8
      ); // fallback to a blue if your variable isn't set
      --background-checked: var(--color-sw-blue, #60baf8);
      --indicator-color: var(--color-sw-blue, #60baf8);
      --ion-color-step-350: var(--color-sw-blue, #60baf8);
      // Unselected buttons
      --color: var(--color-sw-blue, #60baf8);

      // Optionally, adjust background for the segment itself
      --background: #fff; // or whatever you want for the segment bar background
    }
  }
  ion-segment[color="secondary"] ion-segment-button.ios {
    --color-checked: #fff;
    --background-checked: var(--color-sw-blue, #60baf8);
    --indicator-color: var(--color-sw-blue, #60baf8);
    --color: var(--color-sw-blue, #60baf8);
    &.segment-button-checked {
      color: #fff;
    }
    ion-label {
      padding: 0 8px;
    }
  }

  .sw-small-modal {
    padding-top: var(--ion-safe-area-top);
    padding-bottom: var(--ion-safe-area-bottom);
    .modal-wrapper {
      --background: transparent;
      --box-shadow: none;
      --max-width: 90%;
      --max-height: 95%;
      --width: 400px;
      --border-radius: var(--platform-border-radius);
      @media (min-width: 500px) {
        --height: 600px;
      }
    }
    ion-toolbar {
      padding-top: 0 !important;
    }
    &.center-text {
      ion-footer.footer-cta .message {
        text-align: center;
      }
    }
  }
  ion-modal.sw-custom-workout {
    --border-radius: 12px;
    --box-shadow: var(--sw-box-shadow);
    --max-width: 580px;
    --max-height: 360px;
    @media (max-width: 768px) {
      --max-width: 420px;
      --max-height: 360px;
    }
    @media (max-width: 576px) {
      --max-width: 320px;
      --max-height: 380px;
    }
    ion-content {
      --background: var(--ion-color-step-0);
    }
  }

  ion-modal.sw-large-modal {
    @media (min-width: 768px) {
      --min-width: 90%;
      --min-height: 90%;
    }
  }

  ion-modal.sw-cooldown-transition {
    --background: #2d3e4c;
    --backdrop-filter: blur(5px);
    --width: 100%;
    --height: 100%;
    ion-content {
      --background: #2d3e4c;
    }
    ion-toolbar {
      --background: #2d3e4c;
    }
  }

  .workouts-wrapper-grid {
    padding: 12px 12px 24px;
    display: grid;
    grid-column-gap: 12px;
    grid-row-gap: 8px;
    grid-template-columns: repeat(auto-fill, minmax(165px, 1fr));
    sw-workout-card,
    sw-learning-library-card {
      width: inherit;
      margin: 0;
      margin-right: 0 !important;
    }
    @media (max-width: 370px) {
      grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    }
  }
  table.sw-table {
    empty-cells: show;
    border: 1px solid var(--ion-border-color);
    border-collapse: collapse;
    border-spacing: 0;

    thead tr {
      &:first-child th {
        position: sticky;
        top: -1px;
        vertical-align: middle;
        white-space: nowrap;
      }
      th {
        background-color: var(--ion-color-step-50);
        border-bottom: 1px solid var(--ion-color-step-100);
        color: var(--ion-text-color);
        text-align: left;
        vertical-align: bottom;
        margin-top: -1px;
        z-index: 1;

        &:after {
          position: absolute;
          content: "";
          top: 0;
          right: -1px;
          bottom: 0;
          width: 1px;
          background: var(--ion-border-color);
        }
      }
    }

    tbody {
      margin-bottom: 20px;
    }

    th,
    td {
      white-space: nowrap;
      border-collapse: collapse;
      border-right: 1px solid var(--ion-border-color);
      border-width: 0 1px 0 0;
      font-size: inherit;
      margin: 0;
      overflow: visible;
      padding: 0.5em 1em;
      text-align: right;
      > ion-button {
        margin: -0.5em -1em;
      }
      &:last-child,
      &:last-child {
        border-right-width: 0;
      }
    }
    tr th:first-child {
      position: sticky;
      left: -1px;
      z-index: 3;
    }
    tr td {
      background: var(--ion-color-step-50);
      border-right: 1px solid var(--ion-color-step-100);
      &:first-child {
        position: sticky;
        left: -1px;
        z-index: 1;
        &:after {
          position: absolute;
          content: "";
          top: 0;
          right: -1px;
          bottom: 0;
          width: 1px;
          background: var(--ion-border-color);
        }
      }
    }
    tr:nth-child(2n-1) td {
      background-color: var(--ion-color-step-100);
      border-right: 1px solid var(--ion-color-step-50);
    }
  }
  .sticky-left {
    //so that on mobile only the table scrolls left
    position: sticky;
    left: 0;
  }
  .sw-segment-wrapper {
    display: flex;
    justify-content: center;
    ion-segment {
      width: inherit;
    }
  }
  .sw-pacer-wrapper {
    position: relative;
    z-index: 1;
  }
  .sw-pacer {
    border: 5px solid transparent;
    width: 4px;
    background: transparent;
    position: absolute;
    z-index: 1;
    top: -5px;
    transform: translateX(-50%);
  }
  ion-button::part(native) {
    //styling the workout-play-button on sw-player-controls in shadow-root
    font-size: 90%;
  }
  .workout-logs {
    border: 1px solid var(--ion-border-color);
    border-radius: 12px;
    box-shadow: 0 2px 20px var(--color-sw-background-overlay-light);
    padding-top: 8px;
    padding-bottom: 8px;
    ion-item::part(native) {
      background: var(--ion-color-step-0);
    }
  }
  [hidden] {
    display: none !important;
  }
  .iphone-wrapper {
    margin-top: 50px;
    background: var(--ion-color-step-0);
    position: relative;
    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: -50%;
      right: 50%;
    }
    ul {
      margin-top: 40px;
      li {
        list-style: none;
        position: relative;
        padding-left: 30px;
        margin-bottom: 18px;
        text-align: left;
        ion-icon {
          position: absolute;
          top: -2px;
          left: 0;
          font-size: 24px;
          color: var(--color-sw-orange);
        }
      }
    }
  }
  .video-wrapper {
    max-width: 600px !important;
    margin: 0 auto 16px;
    position: relative;
    box-shadow: var(--sw-box-shadow);
    font-size: 0;
    ion-button {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin: 0;
      height: 60px;
      width: 60px;
      --border-radius: 50%;
      --padding-end: 10px;
    }
  }
  ion-row.scrollable-row,
  sw-scrollable-row.scrollable-row,
  sw-scrollable-row.scroll-wrapper {
    flex-wrap: nowrap;
    overflow-x: auto !important;
    overflow-y: hidden;
    height: 100%;
    --scrollable-row-background: var(--ion-background-color);
    --scrollbar-thumb: var(--color-sw-grey-2);
    --scrollbar-thumb-border: 6px solid transparent;
    @media (prefers-color-scheme: dark) {
      --scrollbar-thumb: var(--color-sw-blue-steel-2);
    }

    /* Custom scrollbar styles */
    &::-webkit-scrollbar {
      -webkit-appearance: none;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      border: var(--scrollbar-thumb-border);
      background: var(--scrollbar-thumb);
      background-color: var(--scrollbar-thumb);
      background-clip: content-box;
      border-radius: 8px;
    }

    :root[mode="ios"] & {
      &::-webkit-scrollbar:horizontal {
        height: 8px;
      }
      --scrollbar-thumb-border: 2px solid transparent;
      padding-bottom: 8px;
    }

    @media (hover: hover) {
      &::-webkit-scrollbar:vertical {
        width: 12px;
      }
      &::-webkit-scrollbar:horizontal {
        height: 8px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 8px;
        border: var(--scrollbar-thumb-border);
        background-color: var(--scrollable-row-background);
      }
      &:hover {
        &::-webkit-scrollbar-thumb {
          background-color: var(--scrollbar-thumb);
        }
      }
    }
  }
  ion-text.collection-title {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: var(--sw-grey-1);
  }
  .workout-page-header {
    display: flex;
    width: 100%;
    padding: 5px 33px 8px 32px;
    justify-content: center;
    align-items: center;
    background: rgba(19, 29, 40, 0.5);
    position: absolute;
    bottom: 0px;
  }
  .recommended-section-wrapper {
    background: var(--ion-item-background);
    border-radius: 12px;
    box-shadow: var(--sw-box-shadow);
    margin: 16px;
    ion-label.recommended-title {
      text-wrap: wrap;
      text-transform: uppercase;
    }
    ion-list {
      border-radius: 12px;
      box-shadow: var(--sw-box-shadow);
    }
    ion-item.plan-description {
      --inner-padding-top: 16px;
      // --inner-padding-bottom: 16px;
    }
  }
  .full-page-loading {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: url("/assets/img/blue-bg.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 50;
    display: flex;
    sw-donut-element {
      position: absolute;
      bottom: 0;
      right: 0;
      z-index: 0;
      svg {
        transform: translate(50%, 50%);
      }
    }
  }
  ion-modal.collection-categories-modal {
    ion-content {
      --border-radius: 20px 20px 0 0;
      --padding-top: 16px;
    }
    div.collection-categories-modal-content {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
      gap: 5%;
      padding: 16px;
      @media (max-width: 576px) {
        grid-template-columns: repeat(3, 30%);
      }

      > div.collection-modal-button {
        padding: 0 4px;
        display: flex;
        flex-direction: column;
        gap: 4px 0;
        align-items: center;
        text-align: center;
        @media (max-width: 576px) {
          padding: 0 10px 0 10px;
        }
        ion-button {
          --background: var(--color-sw-grey-4);
          --color: var(--color-sw-blue-steel-2);
          --color-activated: var(--ion-color-primary);
          --color-focused: var(--ion-color-primary);
          --color-hover: var(--ion-color-primary);
          --box-shadow: rgba(0, 0, 0, 0.15) 3px 2px 8px 0px;
          --padding-start: 0;
          --padding-end: 0;
          width: 56px;
          height: 56px;
          @media (max-width: 576px) {
            width: 48px;
            height: 48px;
          }
          @media (prefers-color-scheme: dark) {
            --background: var(--color-sw-blue-steel-2);
            --color: var(--color-sw-grey-3);
          }
          ion-icon {
            width: 36px;
            height: 36px;
            @media (max-width: 576px) {
              width: 28px;
              height: 28px;
            }
            --color: var(--ion-color-medium);
            @media (prefers-color-scheme: dark) {
              --color: var(--color-sw-grey-3);
            }
          }
        }
        .collection-category-name {
          font-size: 16px;
          line-height: 1.2;
          text-align: center;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          line-clamp: 3;
          -webkit-box-orient: vertical;
          @media (max-width: 576px) {
            font-size: 14px;
          }
        }
      }
    }
  }
  ion-popover.sworkit-admin-help-popover {
    --width: 80vw;
  }
  ion-popover.portal-date-range-change-popover {
    --min-width: 320px;
    --height: auto;
  }
  ion-popover.portal-date-picker-popover {
    --min-width: 70vw;
    --height: auto;
  }
  ion-popover,
  ion-modal {
    .portal-popover-header > h5 {
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      min-height: 1.2em;
      letter-spacing: 0.5px;
      padding-inline-start: 16px;
      --padding-start: 16px;
    }
  }
  .dot-wrapper {
    text-align: center;
    ion-button {
      display: inline-block;
      margin: 0 !important;
    }
  }
  /* Hide the tab bar globally when needed */
  .hide-tabbar sw-tabs ion-tab-bar {
    display: none;
  }
  .quill-viewer {
    border: none !important;
  }
  ion-toolbar.language-select-toolbar {
    --background: transparent;
  }
  ion-item.language-select-item {
    --border-radius: 8px 8px 0 0;
    --border-bottom: none;
    --border-color: #ccc;
    --border-width: 1px;
    --border-style: solid;
    margin-top: 1rem;
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .quill-editor {
    height: 500px;
    background: var(--ion-item-background);
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .ql-toolbar {
    border-bottom-width: 2px;
    background: var(--ion-item-background);
    margin-left: 1rem;
    margin-right: 1rem;
  }
  .ql-container {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    // min-height: 80px;
    // max-height: 70%;
    font-family: var(--ion-font-family);
  }
  .ql-editor {
    min-height: 80px;
    font-size: 16px;
    line-height: 1.5;
    // max-height: 70%;
  }
  .quill-viewer {
    min-height: 80px;
    font-family: var(--ion-font-family);
  }
  .quill-viewer .ql-editor {
    padding: 0;
    font-size: 16px;
    line-height: 1.5;
  }
  .quill-viewer .ql-placeholder {
    color: var(--ion-color-medium);
    font-style: italic;
  }

  @media (prefers-color-scheme: dark) {
    .ql-snow {
      .ql-toolbar {
        background-color: var(--ion-color-dark-tint);
        border-color: var(--ion-color-dark-shade);
      }
      .ql-container {
        background-color: var(--ion-color-dark-tint);
        border-color: var(--ion-color-dark-shade);
        color: var(--ion-color-light);
      }
      .ql-editor {
        color: var(--ion-color-light);
      }
      .ql-editor.ql-blank::before {
        color: var(--ion-text-color-step-250) !important;
      }
      .ql-stroke {
        stroke: var(--ion-color-light);
      }
      .ql-fill {
        fill: var(--ion-color-light);
      }
      .ql-snow .ql-picker {
        color: var(--ion-color-light);
      }
      .ql-picker-options {
        background-color: var(--ion-color-dark-tint);
        border-color: var(--ion-color-dark-shade);
      }
      .ql-picker-item {
        color: var(--ion-color-light);
      }
      .ql-picker-label {
        color: var(--ion-color-light);
      }
      .ql-snow .ql-fill,
      .ql-snow .ql-stroke.ql-fill {
        fill: var(--ion-color-light);
      }
    }
  }
  ion-item.item-border-outline {
    border-radius: 6px;
    border: 1px solid var(--ion-text-color-step-500);
    background: var(--ion-content-background);
  }
  ion-popover.sw-challenge-create-team {
    --min-width: 360px;
    --max-width: 420px;
    --width: 380px;
    --height: 320px; // set a fixed height
    --border-radius: 16px;
    box-sizing: border-box;
    overflow: hidden;

    .popover-content {
      height: 320px !important; // match the --height above
      max-height: 320px !important;
      min-height: 320px !important;
      overflow: hidden !important;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    ion-content {
      flex: 1 1 auto;
      height: 200px !important;
      max-height: 200px !important;
      overflow: hidden !important;
    }

    @media (max-width: 576px) {
      --min-width: 95vw;
      --width: 95vw;
      --max-width: 100vw;
      --min-height: 40vh;
      --height: 40vh;
      --max-height: 50vh;
      --border-radius: 12px;
      overscroll-behavior-y: contain;

      .popover-content {
        height: auto !important;
        max-height: 100% !important;
        min-height: 0 !important;
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        overscroll-behavior-y: contain;
      }

      ion-content {
        flex: 1 1 auto;
        height: 100% !important;
        max-height: 100% !important;
        min-height: 0 !important;
        overflow: auto !important;
        overscroll-behavior-y: contain;
      }
    }
  }
  ion-popover.sw-challenge-joined {
    --min-width: 95vw;
    --max-width: 95vw;
  }
  ion-popover.sw-challenge-share-team-invite {
    --min-width: 95vw;
    --max-width: 95vw;
  }
  //SwChallengeShareTeamInvite Functional Component styles
  .share-team-invite-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    ion-label.invite-url-label {
      //@todo - test on build, not working on localhost to highlight text
      user-select: text;
      cursor: text;
      font-family: var(--font-family-monospace);
      background: var(--ion-content-background);
      border-radius: 10px;
      padding: 16px;
      font-size: 0.75rem;
    }
  }
  ion-button.copy-invite-url-button {
    --background: var(--ion-color-secondary);
    --background-hover: var(--ion-color-secondary);
    --background-focused: var(--ion-color-secondary-shade);
    --background-activated: var(--ion-color-secondary-shade);
    --color: var(--color-sw-blue-steel-2);
    font-size: 16px;
    font-weight: 600 !important;
    text-transform: capitalize;
  }
}
